<template>
  <div class="carouzel">
    <v-carouzel :slides="heroCarouselImages" />
  </div>
</template>

<script>
import VCarouzel from '@/components/atomic/VCarouzel.vue';

export default {
  name: 'HomeCarouzel',
  components: {
    VCarouzel,
  },
  data() {
    return {
      heroCarouselImages: [
        {
          id: 1,
          img:
            'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_1600/v1597072261/locations/rizes-house_locations-libroxio_1_sqnlas.jpg',
          alt: 'libroxio beach',
        },
        {
          id: 4,
          img:
            'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_1600/v1597072181/outdoor-areas/rizes-house_outdoor-area_1_mhqxpo.jpg',
          alt: 'rizes house',
        },
        {
          id: 2,
          img:
            'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_1600/v1603912551/rodia-room/rizes-house_rodia-room_39_w2kuse.jpg',
          alt: 'rizes-house rodia-room',
        },
        {
          id: 3,
          img:
            'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_1600/v1597072180/outdoor-areas/rizes-house_outdoor-area_2_lilywg.jpg',
          alt: 'agios nikolaos',
        },
        {
          id: 5,
          img:
            'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_1600/v1603910525/elia-room/rizes-house_elia-room_32_wvmdl8.jpg',
          alt: 'rizes-house elia-room',
        },

        {
          id: 6,
          img:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_1600/v1618335620/Home%20-%20Carousel/DSC_19571_wa2d11.jpg',
          alt: 'rizes-house',
        },
        {
          id: 7,
          img:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_1600/v1618335619/Home%20-%20Carousel/DSC_2706_qxxyfn.jpg',
          alt: 'rizes-house',
        },
        {
          id: 8,
          img:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_1600/v1618335619/Home%20-%20Carousel/DSC_2579_sui556.jpg',
          alt: 'rizes-house',
        },
        {
          id: 9,
          img:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_1600/v1618335619/Home%20-%20Carousel/DSC_2643_dgz9pc.jpg',
          alt: 'rizes-house',
        },
      ],
    };
  },
};
</script>
